import {Component, Input} from '@angular/core';
import {ImageComponent} from "../image/image.component";
import {LazyLoadingComponent} from "../lazy-loading/lazy-loading.component";
import {TranslocoDirective, TranslocoService} from "@ngneat/transloco";
import {CommonModule, DatePipe} from "@angular/common";
import {RouterLink} from "@angular/router";
import {PageType} from "../../model/page-type";
import {DEFAULT_DATE_FORMAT} from "../../model/constatnt";
import {Issue} from "../../../../../backend";

@Component({
  selector: 'app-issue-template',
  standalone: true,
  imports: [
    CommonModule, RouterLink,
    ImageComponent,
    LazyLoadingComponent,
    TranslocoDirective,
    DatePipe
  ],
  templateUrl: './issue-template.component.html',
  styleUrl: './issue-template.component.scss'
})
export class IssueTemplateComponent {


  constructor(private  translocoService: TranslocoService) {
  }

  @Input()
  issue!: Issue;

  @Input()
  pageType!: PageType

  @Input()
  showAdditionalGraphics: Boolean = false

  isHasLink() {
    return PageType.ISSUE !== this.pageType;
  }

  isHasJournal() {
    //return PageType.ISSUES !== this.pageType;
    return true;
  }

  isHasJournalAbbreviation() {
    if (this.issue === undefined || this.issue.journalAbbreviation === undefined) {
      return false;
    }
    return true;
  }

  public getFullIssueName(){
    var value = [];
    if (this.issue.volume !== undefined ){
      value.push(this.translocoService.translate("section.issue.volume"))
      value.push(": ")
      value.push(this.issue.volume)
    }
    if (value.length > 0 && this.issue.number !== undefined){
      value.push(", ")
    }
    if (this.issue.number !== undefined ){
      value.push(this.translocoService.translate("section.issue.no"))
      value.push(": ")
      value.push(this.issue.number)
    }
    if(this.issue.year !== undefined) {
      value.push(", ")
      value.push(this.issue.year)
    }
    return value.join("");
  }


  protected readonly DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
}
